import React, { useEffect, useState, lazy } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Flame } from 'lucide-react';
export function PricingSection() {
  const [timeLeft, setTimeLeft] = useState({
    h: 2,
    m: 45,
    s: 5
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.s > 0) return {
          ...prev,
          s: prev.s - 1
        };
        if (prev.m > 0) return {
          ...prev,
          m: prev.m - 1,
          s: 59
        };
        if (prev.h > 0) return {
          ...prev,
          h: prev.h - 1,
          m: 59,
          s: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const timeBlocks = [{
    value: timeLeft.h,
    label: 'Horas'
  }, {
    value: timeLeft.m,
    label: 'Minutos'
  }, {
    value: timeLeft.s,
    label: 'Segundos'
  }];
  return <section id="pricing" className="relative overflow-hidden bg-gradient-to-b from-slate-900 via-[#064e3b] to-slate-900 pt-20 pb-0" data-id="element-119">
      <div className="container mx-auto px-4 max-w-3xl text-center relative z-10" data-id="element-120">
        <span className="inline-block px-6 py-2.5 mb-6 rounded-full border border-yellow-400/30 bg-yellow-400/10 text-yellow-300 font-bold tracking-[0.15em] uppercase text-xs" data-id="element-121">
          OFERTA ESPECIAL DE LANZAMIENTO
        </span>

        <h2 className="font-heading text-3xl md:text-5xl font-bold text-white leading-tight mb-10" data-id="element-122">
          Todo lo que necesitás para profesionalizar tu consulta,{' '}
          <span className="text-yellow-400" data-id="element-123">
            por una fracción de su valor real.
          </span>
        </h2>

        <div className="relative inline-block mb-2 w-full max-w-lg mx-auto" data-id="element-124">
          <img src="https://cdn.magicpatterns.com/uploads/jZffEDPzmHH2USTTout28h/Texto_del_parrafo_(10)_(1).webp" alt="Masterpack Protocolos Clínicos de Nutrición" width={800} height={800} loading="lazy" decoding="async" className="w-full h-auto rounded-2xl shadow-2xl shadow-black/50" data-id="element-125" />
          <div className="absolute -top-4 -right-4 md:-top-6 md:-right-6 w-28 h-28 md:w-32 md:h-32 flex items-center justify-center" data-id="element-126">
            <div className="absolute inset-0 bg-red-600 rotate-12 shadow-lg" style={{
            clipPath: 'polygon(50% 0%, 61% 12%, 78% 6%, 79% 24%, 96% 30%, 86% 45%, 100% 58%, 83% 64%, 86% 82%, 68% 80%, 60% 97%, 47% 84%, 30% 92%, 28% 73%, 9% 72%, 19% 56%, 4% 45%, 21% 38%, 14% 20%, 33% 22%, 38% 4%)'
          }} data-id="element-127" />
            <div className="relative text-center text-white leading-none rotate-12" data-id="element-128">
              <div className="text-3xl md:text-4xl font-black" data-id="element-129">76%</div>
              <div className="text-[10px] md:text-xs font-bold tracking-wider mt-1" data-id="element-130">
                OFF
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="comprar" className="container mx-auto px-4 max-w-md relative z-10 pb-16 -mt-8 scroll-mt-6" data-id="element-131">
        <div className="bg-white rounded-3xl shadow-2xl shadow-black/20 p-8 text-center border-4 border-yellow-400" data-id="element-132">
          <div className="text-slate-500 text-lg mb-2" data-id="element-133">
            Valor Real: <span className="line-through" data-id="element-134">$83.900 ARS</span>
          </div>

          <div className="inline-flex items-center gap-2 bg-red-100 text-red-700 font-bold px-4 py-2 rounded-full text-sm mb-4" data-id="element-135">
            <Flame className="w-4 h-4" data-id="element-136" /> OFERTA POR TIEMPO LIMITADO
          </div>

          <div className="font-heading text-6xl md:text-7xl font-black text-slate-900 leading-none mb-2" data-id="element-137">
            $19.990
          </div>
          <p className="text-slate-500 text-sm mb-6 font-medium" data-id="element-138">
            Pago único. Licencia de uso de por vida para todos tus pacientes.
          </p>

          <div className="flex justify-center gap-3 mb-8" data-id="element-139">
            {timeBlocks.map(block => <div key={block.label} className="bg-slate-100 text-slate-800 rounded-xl px-4 py-3 min-w-[80px] border border-slate-200" data-id="element-140">
                <div className="font-heading text-3xl font-bold leading-none" data-id="element-141">
                  {String(block.value).padStart(2, '0')}
                </div>
                <div className="text-[10px] font-bold uppercase mt-1 text-slate-500" data-id="element-142">
                  {block.label}
                </div>
              </div>)}
          </div>

          <motion.a id="comprar-cta" href="https://masterpack-de-protocolos-clinicos-de-nutricion.impultienda.ar/checkout" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="scroll-mt-24 flex items-center justify-center gap-3 w-full bg-yellow-400 hover:bg-yellow-300 text-slate-900 font-black text-lg md:text-xl px-6 py-5 rounded-full shadow-lg shadow-yellow-500/30 transition-colors mb-4" data-id="element-143">
            <span data-id="element-144">🚀 QUIERO EL MASTERPACK HOY</span>
            <ArrowRight className="w-6 h-6" data-id="element-145" />
          </motion.a>

          <p className="text-xs text-slate-500 font-medium" data-id="element-146">
            🔒 Pago 100% seguro. Entrega inmediata por email.
          </p>
        </div>
      </div>
    </section>;
}